import React from 'react';
import HolidayFormPageContainer from './HolidayFormPageContainer'

export class HolidayFormPage extends React.Component {
    render(){
        return (
            <HolidayFormPageContainer {...this.props}/>
        )
    }
}